module.exports = __webpack_public_path__ + "media/images/covid/banner/art_bot/ko-0aa8a7c769dad2ff5368f95668a3b221.jpg";